import { Injectable } from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  helper: JwtHelperService = new JwtHelperService();
  
  
  constructor() { }
  
  isTokenExpired() {
    let tokenApi = localStorage.getItem('id_token_api') ?? '';
    return this.helper.isTokenExpired(tokenApi);
  }
}
